import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "h-12" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="https://i.imgur.com/Dp9mvhx.png" 
        alt="Energy Solaris Logo" 
        className="h-full w-auto object-contain"
      />
    </div>
  );
};

export default Logo;